// extracted by mini-css-extract-plugin
export default {"paginationBttns":"styles_paginationBttns__kYsK6","paginationSelected":"styles_paginationSelected__aFkrD"};